import { CompareResult } from "models/hr-dashboard";

interface CompareTableProps {
    data: CompareResult;
}

const ROWS: { label: string; key: "employees" | "consultants" | "total"; bold?: boolean }[] = [
    { label: "Employees", key: "employees" },
    { label: "Consultants", key: "consultants" },
    { label: "Total", key: "total", bold: true },
];

// Balance at the end of each month
const CompareTable = ({ data }: CompareTableProps) => (
    <div className="table-responsive">
        <table className="table table-sm table-bordered mb-0">
            <thead>
                <tr>
                    <th rowSpan={2} className="align-middle">Balance end of month</th>
                    {[1, 2, 3, 4].map(q => (
                        <th key={q} colSpan={3} className="text-center">Q{q} FY{data.fiscalYear}</th>
                    ))}
                </tr>
                <tr>
                    {data.months.map(m => (
                        <th key={m.key} className="text-end">
                            {m.label}
                            {m.isMtd && <div className="small fw-normal text-muted">Month-to-date</div>}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {ROWS.map(row => (
                    <tr key={row.key} className={row.bold ? "fw-bold" : undefined}>
                        <td>{row.label}</td>
                        {data.months.map(m => (
                            <td key={m.key} className="text-end">{m[row.key] ?? "—"}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default CompareTable;
